import { render, staticRenderFns } from "./CambioEspecialistaTratamientos.vue?vue&type=template&id=6383b0fb"
import script from "./CambioEspecialistaTratamientos.vue?vue&type=script&lang=js"
export * from "./CambioEspecialistaTratamientos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports